(function () {
    'use strict';

    angular
        .module('franchisee-portal.services')
        .service('ValidationMessageService', ValidationMessageService)

    /** @ngInject */
    function ValidationMessageService() {
        const ValidationMessageService = {
            getMessage: getMessage
        }

        return ValidationMessageService;

        function getMessage(messageType) {
            const messages = {
                required: 'Campo Obrigatório',
                email: 'Forneça um e-mail válido',
                date: 'Forneça uma data válida',
                number: 'Forneça um número válido',
                url: 'Forneça uma url válida',
                cep: 'Forneça um CEP válido',
                cpf: 'Forneça um CPF válido',
                cnpj: 'Forneça um CNPJ válido',
                phone: 'Forneça um telefone válido',
                ddd: 'Forneça um DDD válido'
            }

            return messages[messageType];
        }
    }
}());